import React from 'react';
import { useNewsStore } from '../stores/newsStore';

// ponytail: NewsContext thin facade mapping to newsStore.
export const useNews = () => {
  return useNewsStore();
};

export const NewsProvider = ({ children }) => {
  return <>{children}</>;
};

export default useNewsStore;
